import './propList.css'

function PropList({title, active, setSelected, id}) {
    return (
        <li className={active ? 'li active' : 'li'} onClick={() => setSelected(id)}>
            {title}
        </li>
    )
}

export default PropList
